// pages/FormViewerPage/hooks/useFormViewerHandlers.ts — Handler input pelanggan form
import React from 'react';

export function useFormViewerHandlers(setCustomerData: any) {
    const handleCustomerDataChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setCustomerData((prev: any) => ({ ...prev, [name]: value }));
    };

    const handleWhatsappChange = (phone: string) => {
        setCustomerData((prev: any) => ({ ...prev, whatsapp: phone }));
    };

    return { handleCustomerDataChange, handleWhatsappChange };
}
